import { createFileRoute } from '@tanstack/react-router'
import { EvaluationsPage } from 'pages/evaluations/EvaluationsPage'

export const Route = createFileRoute('/evaluations/')({
  component: EvaluationsPage,
  staticData: {
    title: 'Evaluations',
    layout: {
      enableScrolling: true,
      enforceMaxWidth: false,
      showSearchBar: false,
    },
  },
})
